import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UspCard } from '~app/modules/storyblok/models';
import { environment } from '~env/environment';

@Component({
  selector: 'app-usp-card',
  templateUrl: './usp-card.component.html',
  styleUrls: ['./usp-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UspCardComponent {
  @Input() card: UspCard;
  @Input() isMobile: boolean;
  @Input() market: string;

  cdnUrl = environment.cdnBaseUrl();
}
